<div *ngIf="shouldShowGridComponent()" class="supporting-document-grid page-design document-grid-list">
  <div class="row">
    <div class="col-12">
      <hr class="mt-3" />
      <h6 class="document-grid-title font-weight-bold">Supporting Documents</h6>
    </div>
    <div class="col-12">
      <p-card styleClass="rbac-card gridview w-100">
        <div *ngIf="archiveEnabled" class="document-tab-switch mb-3" role="tablist" aria-label="Document sections">
          <button type="button" class="document-tab-btn" [class.active]="activeTab === 'active'" (click)="activeTab = 'active'; refreshVisibleDocuments()">
            Active Documents
          </button>
          <button type="button" class="document-tab-btn" [class.active]="activeTab === 'archived'" (click)="activeTab = 'archived'; refreshVisibleDocuments()">
            Archived Documents
          </button>
        </div>

        <div *ngIf="!isShowOnlyAvailableDocumentsMode() || isAdditionalUploadInViewOnlyEnabled()" class="document-grid-header d-flex w-100 justify-content-end align-items-center mb-10">
          <button *ngIf="canShowToolbarUpload()" type="button" class="btn btn-primary grid rounded upload-btn" (click)="openUploadModal(uploadModal)">
            {{ buttonLabel || 'Upload' }}
          </button>
        </div>

        <div class="documentHistoryTable pageWrapper gridview">
          <dx-data-grid
            [dataSource]="visibleDocuments"
            [showBorders]="true"
            [rowAlternationEnabled]="false"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [width]="'100%'"
            [columnMinWidth]="80"
            (onRowPrepared)="onRowPrepared($event)">
            <dxo-scrolling mode="standard" showScrollbar="onHover" [useNative]="false"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
              [visible]="true"
              [allowedPageSizes]="[5, 10, 20]"
              [showPageSizeSelector]="true"
              [showNavigationButtons]="true"
              [showInfo]="true"
              [displayMode]="displayMode">
            </dxo-pager>

            <dxi-column caption="Category" cellTemplate="categoryCell"></dxi-column>
            <dxi-column caption="Type" cellTemplate="typeCell"></dxi-column>
            <dxi-column *ngIf="config.section.showColumn" caption="{{ config.section.label || 'Section Name' }}" cellTemplate="sectionCell"></dxi-column>
            <dxi-column dataField="file_name" caption="Filename" cellTemplate="fileNameCell"></dxi-column>
            <dxi-column caption="Document Status" cellTemplate="statusCell"></dxi-column>
            <dxi-column dataField="created_by_name" caption="Uploaded By"></dxi-column>
            <dxi-column dataField="uploaded_at" caption="Date Uploaded" cellTemplate="uploadedDateCell"></dxi-column>
            <dxi-column caption="Actions" [width]="220" [allowSorting]="false" [allowFiltering]="false" cellTemplate="actionsCell" cssClass="action-column" [fixed]="true" fixedPosition="right"></dxi-column>

            <div *dxTemplate="let cell of 'categoryCell'">
              <div class="dropdown-clear-wrapper">
                <img src="assets/images/neveda-images/visual_indicator.svg" class="new-item-star" *ngIf="shouldShowNewItemStar(cell.data)" title="New Item" alt="New Item" />
                <ng-container *ngIf="canEditRowCategory(cell.data); else categoryText">
                  <div class="select-placeholder-wrapper">
                    <select class="form-control accessible-select"
                      [ngModel]="getRowCategoryValue(cell.data)"
                      (ngModelChange)="onRowCategoryChange(cell.data, $event)"
                      [class.has-value]="getRowCategoryValue(cell.data)">
                      <option value="" disabled hidden>{{ placeholderMessage['P0029'] || 'Select Category' }}</option>
                      <option *ngFor="let category of getCategoriesForRow(cell.data)" [value]="category.key">{{ category.value }}</option>
                    </select>
                  </div>
                  <span *ngIf="isRowCurrentlyRequired(cell.data) && !getRowCategoryValue(cell.data)" class="text-danger"> *</span>
                </ng-container>
                <ng-template #categoryText>
                  <span [ngClass]="{'text-muted': !getCategoryLabel(cell.data)}">
                    {{ getCategoryLabel(cell.data) || 'Not provided' }}<span *ngIf="isRowCurrentlyRequired(cell.data)" class="text-danger"> *</span>
                  </span>
                </ng-template>
              </div>
            </div>

            <div *dxTemplate="let cell of 'typeCell'">
              <div class="dropdown-clear-wrapper">
                <ng-container *ngIf="canEditRowType(cell.data); else typeText">
                  <div class="select-placeholder-wrapper">
                    <select class="form-control accessible-select"
                      [ngModel]="cell.data.cd_document_type"
                      (ngModelChange)="onRowTypeChange(cell.data, $event)"
                      [class.has-value]="cell.data.cd_document_type">
                      <option value="" disabled hidden>{{ placeholderMessage['P0030'] || 'Select Type' }}</option>
                      <option *ngFor="let type of getTypesForRow(cell.data)" [value]="type.key">{{ type.value }}</option>
                    </select>
                    <!-- <span class="select-placeholder" *ngIf="!cell.data.cd_document_type">Select Type</span> -->
                  </div>
                </ng-container>
                <ng-template #typeText>
                  <span class="text-muted">{{ getTypeLabel(cell.data) || 'Not provided' }}</span>
                </ng-template>
              </div>
            </div>

            <div *dxTemplate="let cell of 'sectionCell'">
              <span>{{ cell.data?.section_name || '-' }}</span>
            </div>

            <div *dxTemplate="let cell of 'fileNameCell'">
              <span class="file-name-cell" [attr.title]="cell.data?.file_name || ''">
                {{ cell.data?.file_name || '-' }}
              </span>
            </div>

            <div *dxTemplate="let cell of 'uploadedDateCell'">
              <span>{{ formatGridDate(cell.data?.uploaded_at) || '-' }}</span>
            </div>

            <div *dxTemplate="let cell of 'statusCell'">
              <div class="status-cell">
                <span class="status-badge" *ngIf="cell.data?.status" [ngClass]="statusClass(formatDocumentStatus(cell.data))">
                  <span class="dot"></span>
                  {{ formatDocumentStatus(cell.data) }}
                </span>
                <span *ngIf="!cell.data?.status">-</span>
              </div>
            </div>

            <div *dxTemplate="let cell of 'actionsCell'" class="supporting-grid-actioncontainer">
              <div class="action-icons">
                <button *ngIf="canView(cell.data)" type="button" class="action-icon-button" pTooltip="View" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="preview(cell.data, previewModal)">
                  <span class="sr-only">View</span>
                  <span class="material-symbols-outlined">visibility</span>
                </button>
                <button *ngIf="canDownload(cell.data)" type="button" class="action-icon-button" pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="download(cell.data)">
                  <span class="sr-only">Download</span>
                  <span class="material-symbols-outlined">download</span>
                </button>
                <button *ngIf="canDelete(cell.data)" type="button" class="action-icon-button deletebtn" pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openDeleteModal(deleteModal, cell.data)">
                  <span class="sr-only">Delete</span>
                  <span class="material-symbols-outlined material-delete-symbol">delete</span>
                </button>
                <button *ngIf="canMarkValid(cell.data)" type="button" class="action-icon-button activate-btn" pTooltip="Mark as Valid" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="markValid(cell.data)">
                  <span class="sr-only">Mark Valid</span>
                  <span class="material-symbols-outlined material-mark-icon">verified</span>
                </button>
                <button *ngIf="canMarkDeficient(cell.data)" type="button" class="action-icon-button warning-btn" pTooltip="Mark as Deficient" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openDeficientModal(deficientModal, cell.data)">
                  <span class="sr-only">Mark Deficient</span>
                  <span class="material-symbols-outlined material-warn-symbol">warning</span>
                </button>
                <!-- <button *ngIf="canMarkAddressed(cell.data)" type="button" class="fa fa-check-circle valid-btn" pTooltip="Mark as Addressed" tooltipPosition="top" (click)="openAddressedModal(confirmAddressedModel, cell.data)">
                  <span class="sr-only">Mark as Addressed</span>
                </button> -->
                 <button *ngIf="canViewDeficiency(cell.data)" type="button" class="action-icon-button" pTooltip="View Deficiency Notes" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openViewDeficiencyModal(viewDeficiencyModal, cell.data)">
                  <span class="sr-only">View Deficiency</span>
                  <span class="material-symbols-outlined">comment</span>
                </button>
                <button *ngIf="canReplace(cell.data)" type="button" class="action-icon-button" pTooltip="Replace File" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openReplaceModal(uploadModal, cell.data)">
                  <span class="sr-only">Replace</span>
                  <span class="material-symbols-outlined">file_save</span>
                </button>
                <button *ngIf="canUploadRow(cell.data)" type="button" class="upload-row-btn" pTooltip="Upload File" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openUploadModal(uploadModal, cell.data)">
                  <span class="material-symbols-outlined">upload</span>
                  <span>Upload</span>
                </button>
              </div>
            </div>
          </dx-data-grid>
        </div>
      </p-card>
    </div>
  </div>

  <ng-template #uploadModal let-modal>
    <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">{{ uploadMode === 'replace' ? 'Replace Document' : 'Upload Files' }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="requestCloseUploadModal(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <div class="mb-3">
          <label class="col-form-label mb-2">Select File <span class="text-danger">*</span></label>
          <div class="uplaodfile-popup" (click)="markUploadFileTouched()" (focusout)="markUploadFileTouched()">
            <p-fileUpload #fileUpload mode="advanced" name="demo[]" [customUpload]="true" chooseLabel="Upload"
              chooseIcon="pi pi-upload" [dragDrop]="needDragAndDrop" [maxFileSize]="getUploadMaxFileSizeBytes()" [auto]="true"
              [accept]="getUploadAcceptTypes()"
              [invalidFileTypeMessageSummary]="''"
              [invalidFileTypeMessageDetail]="getInvalidFileTypeMessage()"
              [invalidFileSizeMessageSummary]="''"
              [invalidFileSizeMessageDetail]="getInvalidFileSizeMessage()"
              (onError)="handleFileUploadError($event)" (uploadHandler)="onFileSelected($event, fileUpload)">
              <ng-template pTemplate="content" *ngIf="needDragAndDrop">
                <div class="custom-upload-text text-center mt-2">
                  Drag & drop or
                  <a class="choose-link" (click)="fileUpload.choose()">choose a file</a>
                  to upload
                </div>
              </ng-template>
            </p-fileUpload>
          </div>
          <ng-container *ngIf="selectedFile; else noFileUploaded">
            <div class="d-flex flex-column file mt-20">
              <p class="file__name mb-0">{{ selectedFile?.name }}</p>
            </div>
          </ng-container>
          <ng-template #noFileUploaded>
            <div class="no-file-uploaded mt-20">
              <i class="pi pi-file"></i>
              <span>No file uploaded</span>
            </div>
          </ng-template>
          <div *ngIf="getUploadFileInlineError()" class="text-danger small mt-20">{{ getUploadFileInlineError() }}</div>
        </div>

        <div class="mb-3 filedetails">
          <p class="filesformat mb-1">Supported formats: {{ config.validation.allowedExtensions.join(', ') | uppercase }}.</p>
          <p class="filesformat mb-0">Maximum size: {{ config.validation.maxFileSizeMb }} MB.</p>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3" *ngIf="shouldShowUploadCategorySelector()">
            <label class="col-form-label">Category <span class="text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1">
              <select class="form-control"
                [(ngModel)]="uploadDraft.category"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onUploadCategoryChange($event)"
                (blur)="markUploadCategoryTouched()"
                [disabled]="isUploadCategoryDisabled()"
                [style.color]="uploadDraft.category === '' ? '#757575' : '#010101'"
                [ngClass]="{'empty-select': uploadDraft.category === ''}">
                <option value="" hidden>{{ placeholderMessage['P0029'] || 'Select Category' }}</option>
                <option *ngFor="let category of getAvailableCategories()" [value]="category.key">{{ category.value }}</option>
              </select>
            </div>
            <div *ngIf="getUploadCategoryInlineError()" class="text-danger small mt-1">{{ getUploadCategoryInlineError() }}</div>
          </div>

          <div class="col-md-6 mb-3" *ngIf="shouldShowUploadTypeSelector()">
            <label class="col-form-label">Type <span class="text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1">
              <select class="form-control"
                [(ngModel)]="uploadDraft.docType"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onUploadTypeChange($event)"
                (blur)="markUploadTypeTouched()"
                [disabled]="isUploadTypeDisabled()"
                [style.color]="uploadDraft.docType === '' ? '#757575' : '#010101'"
                [ngClass]="{'empty-select': uploadDraft.docType === ''}">
                <option value="" hidden>{{ placeholderMessage['P0030'] || 'Select Type' }}</option>
                <option *ngFor="let type of getUploadTypeOptions()" [value]="type.key">{{ type.value }}</option>
              </select>
            </div>
            <div *ngIf="getUploadTypeInlineError()" class="text-danger small mt-1">{{ getUploadTypeInlineError() }}</div>
          </div>
        </div>
      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn btn-md px-3 py-1" (click)="requestCloseUploadModal(modal)">Cancel</button>
        <button type="button" class="btn btn-primary btn-md rounded ms-2" (click)="saveUpload(modal)" [disabled]="isUploadSaveDisabled()">Save</button>
      </div>
    </div>
  </ng-template>

  <ng-template #duplicateApplicantModal let-modal>
    <div class="modal-shell duplicate-doc-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Duplicate Document Detected</h4>
        <button type="button" class="close" aria-label="Close" (click)="onDuplicateCancel(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-0">
          {{ config.duplicate.blockMessageApplicant || 'This document appears to already exist in this section.' }}
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-end gap-2">
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="onDuplicateCancel(modal)">Close</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #duplicateStaffModal let-modal>
    <div class="modal-shell duplicate-doc-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Duplicate Document Detected</h4>
        <button type="button" class="close" aria-label="Close" (click)="onDuplicateCancel(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-0">
          {{ config.duplicate.blockMessageStaff || 'A matching document already exists in this section.' }}
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-primary btn-md px-3 py-1" (click)="onDuplicateProceed()">Proceed &amp; Upload</button>
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="onDuplicateCancel(modal)">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteModal let-modal>
    <div class="delete-document-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Delete Document</h4>
        <button type="button" class="delete-modal-close" aria-label="Close" style="color: #6c757d;" (click)="cancelDelete(modal)">
          <span aria-hidden="true" style="color: #6c757d;">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="delete-content mb-0">
          Are you sure you want to delete this document? This action cannot be undone.
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
          <button type="button" class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="cancelDelete(modal)">Cancel</button>
          <button type="button" class="btn btn-primary btn-md deletebtn" (click)="confirmDelete(modal)">Delete</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #confirmValidModal let-modal>
    <div class="modal-shell duplicate-doc-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title mb-0">Confirm Validation</h4>
        <button type="button" class="close" aria-label="Close" (click)="cancelValid(modal)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-0">
          This will mark the document as valid, indicating it has been reviewed and found satisfactory.
        </p>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-center gap-2">
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="cancelValid(modal)">Cancel</button>
          <button type="button" class="btn btn-primary btn-md px-3 py-1" (click)="confirmValid(modal)">Proceed</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deficientModal let-modal>
    <div class="modal-shell duplicate-doc-modal deficient-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Confirm Deficiency</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-3">
          This will mark the record as deficient, indicating it has been reviewed and requires correction or additional information.
        </p>
        <label class="form-label">Deficiency Notes <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="4" [(ngModel)]="deficiencyNotes" [ngModelOptions]="{standalone: true}"></textarea>
        <div class="text-danger small mt-2" *ngIf="deficiencyError">{{ deficiencyError }}</div>
      </div>
      <div class="form-modal-footer p-3">
        <div class="modal-actions d-flex justify-content-center gap-2">
          <button type="button" class="btn btn-primary btn-md px-3 py-1" (click)="confirmDeficient(modal)">Proceed</button>
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="modal.dismiss()">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>

 <ng-template #viewDeficiencyModal let-modal>
    <div class="modal-shell duplicate-doc-modal deficient-modal">
      <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">View Deficiency</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body p-3">
        <p class="mb-3">
          This will mark the record as deficient, indicating it has been reviewed and requires correction or additional information.
        </p>
        <label class="form-label">Deficiency Notes</label>
        <textarea class="form-control" rows="4" [(ngModel)]="deficiencyNotes" [ngModelOptions]="{standalone: true}" readonly></textarea>
        <div class="text-danger small mt-2" *ngIf="deficiencyError">{{ deficiencyError }}</div>
      </div>
      <div class="p-3">
        <div class="modal-actions d-flex justify-content-center">
          <button type="button" class="btn document-preview-cancel btn-md px-3 py-1" (click)="modal.dismiss()">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- <ng-template #confirmAddressedModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Mark Deficiency as Addressed</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">Please add a short note explaining how you addressed this deficiency. <span class="text-danger">*</span></p>
      <textarea class="form-control mt-2" rows="4" placeholder="Enter Notes" [(ngModel)]="actionText"
        name="actionText" #actionTextRef="ngModel" required>
</textarea>
    <div class="text-danger" *ngIf="actionTextRef.errors?.required && actionTextRef.dirty">
     Please enter a note.
    </div>
    <div class="text-danger"  *ngIf="wordCount > 100"> Maximum 100 words allowed.</div>
    </div>

    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md" (click)="onMarkAsAddressedItem(modal)"
          [disabled]="actionTextRef.invalid || wordCount > 100">
          Proceed
        </button>

      </div>
    </div>
  </ng-template> -->

  <ng-template #previewModal let-modal>
    <div class="document-preview-header">
      <h4 class="document-preview-title">View Document</h4>
    </div>
    <div class="form-modal-body document-preview-body">
      <ng-container *ngIf="previewUrl; else noPreview">
        <img *ngIf="isImage(previewDocument)" [src]="previewUrl" alt="Preview" class="document-preview-image" />
        <iframe *ngIf="!isImage(previewDocument)" [src]="previewUrl" class="document-preview-frame"></iframe>
      </ng-container>
      <ng-template #noPreview>
        <div class="p-3 text-muted text-center">No preview available.</div>
      </ng-template>
    </div>
    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button type="button" class="btn document-preview-cancel px-3 py-1" (click)="modal.dismiss()">Close</button>
      </div>
    </div>
  </ng-template>
</div>
